import { useInView } from "react-intersection-observer";
import { useUserPhoto } from "./index";

export const useLazyUserPhoto = (userId: string | undefined, enabled: boolean) => {
	const { ref, inView } = useInView({ triggerOnce: true, rootMargin: "100px" });
	const photoUrl = useUserPhoto(userId, inView && enabled);

	return {
		ref,
		image: photoUrl ? { src: photoUrl } : undefined,
	};
};
